"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unBlur = exports.pulse = exports.spinCounterclockwise = exports.spinClockwise = void 0;

var _core = require("@emotion/core");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var spinClockwise = (0, _core.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(359deg);\n  }\n"])));
exports.spinClockwise = spinClockwise;
var spinCounterclockwise = (0, _core.keyframes)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(-359deg);\n  }\n"])));
exports.spinCounterclockwise = spinCounterclockwise;
var pulse = (0, _core.keyframes)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    opacity: .6;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: .6;\n  }\n"])));
exports.pulse = pulse;
var unBlur = (0, _core.keyframes)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  0% {\n    filter: blur(4px);\n  }\n  100% {\n    filter: blur(0px);\n  }\n"])));
exports.unBlur = unBlur;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/styles/animations.js
// module id = 218
// module chunks = 0 15 16 17 18